import { render, staticRenderFns } from "./HomeLawExamTop10.vue?vue&type=template&id=101d08e2&scoped=true"
import script from "./HomeLawExamTop10.vue?vue&type=script&lang=js"
export * from "./HomeLawExamTop10.vue?vue&type=script&lang=js"
import style0 from "./HomeLawExamTop10.vue?vue&type=style&index=0&id=101d08e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101d08e2",
  null
  
)

export default component.exports